<template>
  <b-modal v-if="data.registro"
           id="modal-impressao-inteiro-teor"
           ref="modal-impressao-inteiro-teor"
           class="impressao--modal"
           :content-class="zoomClass"
           size="xl">
    <div v-if="frente"
         class="impressao--tamanho_14 impressao--frente">
      <b-container class="impressao_documento--margin">
        <b-row>
          <b-col cols="5"
                 class="impressao_documento impressao_documento--qrcode-inteiro-teor">
            <div>
              <u>https://selodigital.tjsp.jus.br</u>.
            </div>
            <div style="letter-spacing: -1px;">
              Selo Digital: {{ data.selo.selo_digital || '0000000000000000000000000' }}
            </div>
            <div>
              <img :src="qrCodeImg"
                   class="qrcode"
                   alt="">
            </div>
          </b-col>
        </b-row>
        <b-row>
          <div class="impressao_documento impressao_documento--titulo font--18 text-center">
            CERTIDÃO DE INTEIRO TEOR
            <br>
            {{ tipo | tipos }}
          </div>
        </b-row>

        <b-row class="mt-2 mb-4">
          <div v-if="tipo === 'casamento'"
               class="col-8 impressao_documento--minus-margin-5">
            <div class="pr-0 mb-3">
              <fieldset class="fieldset-impressao">
                <legend>NOME ATUAL DO CÔNJUGE</legend>
                <span class="text-justify bold">
                  {{ data.dados.conjuges.at(0).nome || data.dados.conjuges.at(0).nome_antigo }}
                </span>
              </fieldset>
            </div>
            <div class="pr-0">
              <fieldset class="fieldset-impressao">
                <legend>NOME ATUAL DO CÔNJUGE</legend>
                <span class="text-justify bold">
                  {{ data.dados.conjuges.at(1).nome || data.dados.conjuges.at(2).nome_antigo }}
                </span>
              </fieldset>
            </div>
          </div>

          <div v-else
               class="col-12 text-center mb-3">
            <div class="bold impressao_documento--minus-margin-5 label-font-size">
              NOME
            </div>
            <div class="bold impressao_documento--minus-margin-5">
              {{ data.registro.pessoa && data.registro.pessoa.nome ? data.registro.pessoa.nome : data.pessoa.nome }}
            </div>
          </div>

          <div v-if="tipo === 'casamento'"
               class="col-4 impressao_documento--minus-margin-5">
            <div class="pr-0 mb-3">
              <fieldset class="fieldset-impressao text-center">
                <legend>NÚMERO DO CPF</legend>
                <span class="text-justify bold">
                  {{ data.dados.conjuges.at(0).cpf }}
                </span>
              </fieldset>
            </div>
            <div class="pr-0">
              <fieldset class="fieldset-impressao text-center">
                <legend>NÚMERO DO CPF</legend>
                <span class="text-justify bold">
                  {{ data.dados.conjuges.at(1).cpf }}
                </span>
              </fieldset>
            </div>
          </div>

          <div v-else
               class="col-12 impressao_documento--minus-margin-5">
            <div class="pr-0">
              <fieldset class="fieldset-impressao text-center">
                <legend class="text-center">
                  NÚMERO DO CPF
                </legend>
                <span class="text-justify bold">
                  {{ cpf }}
                </span>
              </fieldset>
            </div>
          </div>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <div class="bold impressao_documento--minus-margin-5 label-font-size">
              Matrícula
            </div>
            <div class="bold impressao_documento--minus-margin-5">
              {{ data.registro.matricula | maskMatricula }}
            </div>
          </b-col>
        </b-row>

        <b-row>
          <div class="col-12">
            <div class="texto-inteiro-teor--texto-1 text-justify font--9 p-1"
                 v-html="data.textoUm " />
          </div>
        </b-row>

        <b-row v-if="data.textoDois">
          <div class="vide-verso text-center font--9">
            VIDE VERSO
          </div>
        </b-row>
        <b-row class="impressao_documento--rodape mt-3 text-center">
          <b-col cols="5"
                 class="font--8 pr-1">
            <div style="white-space: nowrap;">
              Oficial de Registro Civil das Pessoas Naturais
              <br>
              {{ data.cartorio && data.cartorio.nome || 'Não consta' }} - {{ data.cartorio && data.cartorio.endereco ? data.cartorio.endereco.uf : 'Não consta' }}
            </div>
            <div class="mt-2">
              {{ data.oficial || 'Não consta' }} - Oficial
            </div>
            <div v-if="data.cartorio"
                 class="mt-2">
              {{ data.cartorio.endereco && data.cartorio.endereco.logradouro || 'Não consta' }}, nº {{ data.cartorio.endereco && data.cartorio.endereco.numero || 'Não consta' }} - {{ data.cartorio.endereco && data.cartorio.endereco.bairro || 'Não consta' }}
              CEP: {{ data.cartorio.endereco && data.cartorio.endereco.cep || 'Não consta' }} - Fone: {{ data.cartorio.telefone || 'Não consta' }}
              <br>e-mail: {{ data.cartorio.email || 'Não consta' }}
            </div>
          </b-col>
          <b-col>
            <div>
              O Conteúdo da certidão é verdadeiro. Dou fé.
            </div>
            <div v-if="data.cartorio">
              {{ data.cartorio.endereco && data.cartorio.endereco.cidade || 'Não consta' }} - {{ data.cartorio.endereco && data.cartorio.endereco.uf || 'Não consta' }}, {{ data.data_atual || 'Não consta' }}.
            </div>
            <div>
              <hr class="hr--assinatura">
              <div class="d-inline-flex">
                {{ data.assinante.nome || 'Não consta' }} - {{ data.assinante.cargo || 'Não consta' }}
              </div>
            </div>
            <div class="mt-1">
              <div v-if="data.emolumentosFiltrados && !data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match('0,00')">
                Valor pago por essa certidão:<br>
                <span v-for="(emolumento, index) in data.emolumentosFiltrados"
                      :key="`emolumento_${ _uid }_${ index }`">
                  <br v-if="emolumento.destino == 'Total' || emolumento.destino == 'AVERBAÇÕES'">
                  <b v-if="emolumento.destino == 'Total'">{{ emolumento.destino }}: {{ emolumento.valor }};</b>
                  <span v-else>{{ emolumento.destino }}: {{ emolumento.valor }};</span>
                </span>
              </div>

              <div v-if="!data.emolumentosFiltrados || !!data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match('0,00')">
                <b>{{ destino.primeiraVia ? '1ª' : '2ª' }} VIA ISENTA DE EMOLUMENTOS</b>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-if="!frente"
         class="impressao--tamanho_14 impressao--verso">
      <div class="impressao--tamanho_14 impressao--verso">
        <b-container v-if="data.textoDois"
                     class="impressao_documento--margin-verso">
          <b-row>
            <div class="impressao_documento impressao_documento--titulo font--18 text-center mt-0">
              CERTIDÃO DE {{ tipo | tipos }}
            </div>
          </b-row>
          <b-row class="mt-2 mb-4">
            <b-col class="text-center">
              <div class="bold impressao_documento--minus-margin-5">
                <div v-if="tipo === 'casamento'">
                  Nomes: {{ data.dados.conjuges[0].nome || data.dados.conjuges[0].nome_antigo }} e
                  <br>
                  {{ data.dados.conjuges[1].nome || data.dados.conjuges[1].nome_antigo }}
                </div>
                <div v-else>
                  Nome: {{ data.registro.pessoa && data.registro.pessoa.nome ? data.registro.pessoa.nome : data.pessoa.nome }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="text-center">
              <div class="bold impressao_documento--minus-margin-5">
                MATRÍCULA
              </div>
              <div class="bold impressao_documento--minus-margin-5">
                {{ data.registro.matricula | maskMatricula }}
              </div>
            </b-col>
          </b-row>
          <b-row class="my-2 mt-3">
            <b-col class="font--12">
              OBSERVAÇÕES AVERBAÇÕES - <b>CONTINUAÇÃO</b>
            </b-col>
          </b-row>
          <hr class="linha-inteiro-teor">
          <b-row>
            <div class="texto-inteiro-teor text-justify font--10 ml-4 text-break"
                 v-html="data.textoDois " />
          </b-row>

          <b-row class="impressao_documento--rodape mt-3 text-center">
            <b-col cols="5"
                   class="font--8 pr-1">
              <div style="white-space: nowrap;">
                Oficial de Registro Civil das Pessoas Naturais
                <br>
                {{ data.cartorio && data.cartorio.nome || 'Não consta' }} - {{ data.cartorio && data.cartorio.endereco ? data.cartorio.endereco.uf : 'Não consta' }}
              </div>
              <div class="mt-2">
                {{ data.oficial || 'Não consta' }} - Oficial
              </div>
              <div v-if="data.cartorio"
                   class="mt-2">
                {{ data.cartorio.endereco && data.cartorio.endereco.logradouro || 'Não consta' }}, nº {{ data.cartorio.endereco && data.cartorio.endereco.numero || 'Não consta' }} - {{ data.cartorio.endereco && data.cartorio.endereco.bairro || 'Não consta' }}
                CEP: {{ data.cartorio.endereco && data.cartorio.endereco.cep || 'Não consta' }} - Fone: {{ data.cartorio.telefone || 'Não consta' }}
                <br>e-mail: {{ data.cartorio.email || 'Não consta' }}
              </div>
            </b-col>
            <b-col>
              <div>
                O Conteúdo da certidão é verdadeiro. Dou fé.
              </div>
              <div v-if="data.cartorio">
                {{ data.cartorio.endereco && data.cartorio.endereco.cidade || 'Não consta' }} - {{ data.cartorio.endereco && data.cartorio.endereco.uf || 'Não consta' }}, {{ data.data_atual || 'Não consta' }}.
              </div>
              <div>
                <hr class="hr--assinatura">
                <div class="d-inline-flex">
                  {{ data.assinante.nome || 'Não consta' }} - {{ data.assinante.cargo || 'Não consta' }}
                </div>
              </div>
              <div class="mt-1">
                <div v-if="data.emolumentosFiltrados && !data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match('0,00')">
                  Valor pago por essa certidão:<br>
                  <span v-for="(emolumento, index) in data.emolumentosFiltrados"
                        :key="`emolumento_${ _uid }_${ index }`">
                    <br v-if="emolumento.destino == 'Total' || emolumento.destino == 'AVERBAÇÕES'">
                    <b v-if="emolumento.destino == 'Total'">{{ emolumento.destino }}: {{ emolumento.valor }};</b>
                    <span v-else>{{ emolumento.destino }}: {{ emolumento.valor }};</span>
                  </span>
                </div>

                <div v-if="!data.emolumentosFiltrados || !!data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match('0,00')">
                  <b>{{ destino.primeiraVia ? '1ª' : '2ª' }} VIA ISENTA DE EMOLUMENTOS</b>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <template v-slot:modal-header>
      <div class="w-100">
        <div class="float-right">
          <b-button
            size="sm"
            class="ml-2"
            variant="primary"
            :disabled="zoom < 1"
            @click="zoom--">
            <icon-svg class="impressao_documento--icon icons--white icon--xs"
                      icon="zoomMinus" />
          </b-button>
          <b-button
            size="sm"
            class="ml-2 mr-2"
            variant="primary"
            :disabled="zoom > 1"
            @click="zoom++">
            <icon-svg class="impressao_documento--icon icons--white icon--xs"
                      icon="zoomPlus" />
          </b-button>
          <b-button
            v-if="frente"
            variant="secondary"
            size="sm"
            @click="frente = false">
            Visualizar Verso
          </b-button>
          <b-button
            v-if="!frente"
            variant="secondary"
            size="sm"
            @click="frente = true">
            Visualizar Frente
          </b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="default"
            @click="$bvModal.hide('modal-impressao-inteiro-teor')">
            <icon-svg class="impressao_documento--icon icon--xs"
                      icon="close" />
          </b-button>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <div class="w-100">
        <div class="float-right">
          <b-button
            size="sm"
            variant="default"
            class="mr-2"
            @click="$bvModal.hide('modal-impressao-inteiro-teor')">
            Voltar
          </b-button>
          <b-button
            v-if="frente"
            variant="secondary"
            size="sm"
            @click="frente = false">
            Visualizar Verso
          </b-button>
          <b-button
            v-if="!frente"
            variant="secondary"
            size="sm"
            @click="frente = true">
            Visualizar Frente
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
/* image */
  import qrCodeImg from '@/assets/img/qrcode.png'

  export default {
    name: 'ModalInteiroTeor',
    filters: {
      tipos: function (tipo) {
        switch (tipo) {
        case 'nascimento':
          return 'NASCIMENTO'
        case 'obito':
          return 'ÓBITO'
        case 'casamento':
          return 'CASAMENTO'
        default:
          return ''
        }
      }
    },
    props: {
      data: { type: Object, default: () => ({}) },
      tipo: { type: String, default: '' }
    },
    data () {
      return {
        frente: true,
        zoom: 0,
        qrCodeImg,
        destino: {
          primeiraVia: false,
          segundaVia: false
        },
        cpf: ''
      }
    },
    computed: {
      zoomClass: function () {
        let className = ''

        switch (this.zoom) {
        case 2:
          className = 'modalZoom--2'
          break
        case 1:
          className = 'modalZoom--1'
          break
        case 0:
          className = ''
          break
        }

        return className
      }
    },
    watch: {
      data () {
        // Atualiza destino
        this.destino = { primeiraVia: false, segundaVia: false }
        if (this.data.registro.pessoa && this.data.registro.pessoa.cpf) this.cpf = this.data.registro.pessoa.cpf
        else if (this.data.pessoa && this.data.pessoa.cpf) this.cpf = this.data.pessoa.cpf
        const osSelected = this.data.ordemServicoSelected


        if (!osSelected) return

        // Selecionado o item da OS com o selo selecionado
        const itemOsSelecionado = osSelected.itens.find(itemOS => {
          return itemOS.seloItemOs.find(seloItem => seloItem.selo.num_selo === this.data.selo.selo_digital)
        })

        // Verifica se o item da OS está com valor zerado
        const osComItemZerado = itemOsSelecionado && itemOsSelecionado.valor === 0

        // Valida OS e com item zerado
        if (!osSelected || !osSelected.itens.length || (osSelected.valor_total > 0 && !osComItemZerado)) return

        const primeiraVia = osSelected.itens.find(item => !item.flag_cancelado && (item.custa.codigo === 16 || item.custa.codigo === 19)) // AN e AO

        const segundaVia = osSelected.itens.find(item => !item.flag_cancelado && item.custa.codigo !== 16 && item.custa.codigo !== 19)

        if (primeiraVia) {
          this.destino = { primeiraVia: true, segundaVia: false }
        } else if (segundaVia) {
          this.destino = { primeiraVia: false, segundaVia: true }
        }
      }
    }
  }
</script>

<style lang="scss">
@import "@/scss/_utilities/_exports.scss";
@import "@/scss/_components/_modals.scss";
@import "@/scss/_components/_modalCertidao.scss";

  .qrcode {
    width: 100px;
  }
</style>
